import { useMemo } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import FileInput from '../../../FileInput';
import { useAuth } from '../../../../utils/Auth';
import { useTypeHeaderIcon } from '../../../../utils/hooks/useTypeHeaderIcon';
import { useFileUpload } from '../../../../utils/hooks/useFileUpload';
import styles from './PDF.module.css';
import FilesList from '../../../FilesList';

const PDF = (_) => {
    const acceptableFileTypes = ['application/pdf'];
    
    const { qr_data } = useAuth();

    const { header } = useTypeHeaderIcon(qr_data?.data?.qr_type);
    const fileHelpers = useFileUpload({ acceptableFileTypes, type: 'pdf' });
    const { handleFileSelected, filesToDisplay, error } = fileHelpers;

    const disabled = useMemo(() => (filesToDisplay?.length > 0) ? true : false, [filesToDisplay?.length]);

    return (
        <div className={styles.container}>
            <OverlayTrigger
                placement='top'
                delay={{ show: 250, hide: 400 }}
                trigger={['click', 'hover']}
                overlay={<Tooltip><p>Upload your {header}. Scanning your QR will redirect the user to this {header}'s file.</p></Tooltip>}
            >
                <h5 className='mb-0'>{header} File(s) <i className='fa-regular fa-circle-info' /></h5>
            </OverlayTrigger>
            {error && <div className={styles.error}>{error}</div>}
            <FilesList fileHelpers={fileHelpers} />
            {!disabled && 
                <FileInput
                    onFileSelect={handleFileSelected}
                    acceptedFileTypes={'.pdf'}
                    multiple={false}
                    label={'Upload PDF'}
                    id={'pdf-file-input'}
                    name={'pdfFile'}
                    disabled={disabled}
                />
            }
        </div>
    );
};

export default PDF;